/* Quita el bloque de codigo con que el modelo envuelve a veces la vista previa
   del presupuesto (```markdown ... ```). Dentro de un bloque el chat la pinta
   como codigo fuente, con numeros de linea, en vez de como tabla. Pasaba en ~1
   de cada 5 previas en produccion (20/09-13/10, gpt-5.2).

   Es la MISMA regla que `desenvolver_previa` en
   back/src/tools/renderizar_previa.py. El backend la aplica al mensaje que se
   guarda; aqui hace falta tambien porque el texto llega en streaming tal como lo
   genera el modelo, y por las conversaciones guardadas antes del arreglo.

   Solo se toca un bloque cuya primera linea es la cabecera que pinta
   `renderizar_previa`: un bloque de codigo legitimo (un mermaid, un ejemplo) no
   la lleva. */

const APERTURA = /^[ \t]*```[ \t]*(?:markdown|md)?[ \t]*$/i;
const CIERRE = /^[ \t]*```[ \t]*$/;
const CABECERA = /^#{2,3} (?:Vista previa del presupuesto|PRESUPUESTO )/;
const CABECERAS = ["### Vista previa del presupuesto", "## PRESUPUESTO "];

/* En streaming la cabecera puede estar a medias ("### Vis"): si es la ultima
   linea y encaja como principio de una cabecera, se da por buena. Sin esto, la
   previa se veria como codigo hasta completar la primera linea. */
function esCabecera(linea: string, esUltima: boolean): boolean {
  if (CABECERA.test(linea)) return true;
  return esUltima && linea.length > 0 && CABECERAS.some((c) => c.startsWith(linea));
}

export function desenvolverPrevia(texto: string): string {
  if (!texto.includes("```")) return texto;
  const lineas = texto.split("\n");
  const salida: string[] = [];
  let i = 0;
  while (i < lineas.length) {
    if (
      APERTURA.test(lineas[i]) &&
      i + 1 < lineas.length &&
      esCabecera(lineas[i + 1], i + 2 === lineas.length)
    ) {
      let cierre = -1;
      for (let j = i + 1; j < lineas.length; j++) {
        if (CIERRE.test(lineas[j])) {
          cierre = j;
          break;
        }
      }
      // Sin cierre (aun llegando, o el modelo no lo puso): el resto ES la previa.
      if (cierre === -1) {
        salida.push(...lineas.slice(i + 1));
        break;
      }
      salida.push(...lineas.slice(i + 1, cierre));
      i = cierre + 1;
      continue;
    }
    salida.push(lineas[i]);
    i++;
  }
  return salida.join("\n");
}
